<template src="./validBase.htm" />

<script>
import func from "@/modules/functions.js";

export default func.validBase(func.arrValid);
</script>
